import { render, staticRenderFns } from "./CourseSyllabus.vue?vue&type=template&id=cda1c0fa"
import script from "./CourseSyllabus.vue?vue&type=script&lang=js"
export * from "./CourseSyllabus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports